// 会员卡
export default {
    heard_title: "会员卡",
    heard_btn: "开卡",

    fl_keyword: "用户账号:",
    fp_keyword: "手机号码/昵称",
    fl_code: "会员卡号:",
    fp_code: "会员卡号",
    fl_startTime: "发卡时间:",
    fp_startTime: "请选择时间",
    fl_status: "会员卡状态:",
    op_all: "全部",
    op_normal: "正常",
    op_frozen: "已冻结",
    op_expired: "已过期",
    op_canceled: "已注销",

    tl_mobile: "用户账号",
    tl_name: "用户昵称",
    tl_levelName: "会员卡类型",
    tl_code: "卡号",
    tl_walletBalance: "可用余额",
    tl_orderQuantity: "订单数量",
    tl_createTime: "发卡时间",
    tl_status: "会员卡状态",
    btn_viewUser: "查看用户",
    btn_recharge: "充值",
    btn_other: "其他操作",

    // 开卡弹出框
    dt_openCard: "开卡",
    dl_serialNo: "芯片ID:",
    dp_serialNo: "请刷卡读取",
    dl_mobile: "用户账号",
    dp_mobile: "用户账号",
    dl_code: "会员卡号",
    dp_code: "请输入会员卡号",
    dl_validaDays: "有效期",
    dp_validaDays: "请输入",
    dp_unit: "天",
    dl_password: "设置密码",
    dp_password: "请输入",
    dp_confirmPassword: "再次输入",
    btn_sendCard: "发卡",

    // 其他操作弹出框
    dt_operator: "其他操作",
    dl_nickName: "用户昵称:",
    dl_userMobile: "用户账号:",
    dl_memberCode: "会员卡号:",
    dl_walletBalance: "会员余额:",
    dl_levelName: "会员卡类型:",
    dl_createTime: "发卡时间:",
    btn_rechargeCard: "充值",
    btn_loss: "挂失",
    btn_active: "激活",
    btn_cancel: "注销",
    btn_editPassword: "修改密码",
    btn_resetPassword: "重置密码",

    // 修改密码弹出框
    dt_editPass: "修改密码",
    dp_paymentPassword: "请输入密码",
    dp_comfirmPass: "请再次输入密码",

    // 注册弹框
    dt_register: "注册",
    dl_registerMobile: "手机号码",
    dp_registerMobile: "请输入手机号码",
    dl_name: "昵称",
    dp_nickName: "请输入昵称",
    btn_register: "注册",

    // 提示
    em_codeRequire: "请输入卡号",
    em_codeRule: "请输入8位卡号",
    em_mobileRule: "请输入合法的手机号码",
    em_password: "两次输入的密码不一致",
    em_passwordRange: "请输入六位密码",
    sm_openCard: "开卡成功",
    em_openCard: "开卡失败",
    em_mobileStatus: "该手机号还未注册,请先注册",
    em_nickName: "请输入昵称",
    sm_register: "注册成功",
    em_register: "注册失败",
    sm_lost: "挂失成功",
    em_lost: "挂失失败",
    sm_active: "激活成功",
    em_active: "激活失败",
    msg_cancel: "此操作将注销该会员卡, 是否继续?",
    sm_cancel: "注销成功",
    em_cancel: "注销失败",
    im_cancel: "已取消",
    msg_confirm: "此操作将重置会员卡支付密码, 是否继续?",
    sm_resetPass: "重置密码成功",
    em_resetPass: "重置密码失败",
    im_resetPass: "已取消",
    sm_editPass: "修改密码成功",
    em_editPass: "修改密码失败",
    em_passRequire: "密码不能为空",

    ft_normal: "正常",
    ft_frozen: "已冻结",
    ft_expired: "已过期",
    ft_canceled: "已注销"
};
